import { useSettings } from '@features/settings';

export const useCurrentUser = () => {
  const settings = useSettings();

  return {
    ...settings.user,
    userType: settings.userType,
    role: settings.role,
  };
};
